module.exports = __webpack_public_path__ + "media/images/prize__matchday@2x-37df18317eff5e0de95c198cb35025b2.jpg";